/**
 * Client-side context for Discord activity / product analytics (session, device).
 */

const SESSION_KEY = "lo_activity_sid_v1";

export function getActivitySessionId() {
  if (typeof window === "undefined") return "";
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `sess_${Date.now().toString(36)}_${Math.random()
        .toString(36)
        .slice(2, 14)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `sess_fb_${Date.now()}`;
  }
}

/** coarse device class for reporting */
export function getDeviceType() {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/tablet|ipad|playbook|silk/i.test(ua) && !/mobi/i.test(ua))
    return "tablet";
  if (/mobi|iphone|ipod|android.*mobile|blackberry|opera mini|iemobile/i.test(ua))
    return "mobile";
  return "desktop";
}

export function getViewportSummary() {
  if (typeof window === "undefined") return "";
  return `${window.innerWidth}x${window.innerHeight}`;
}
